<template>

<div>
	
	<textarea v-on:keyup="selectChange()" v-on:change="selectChange()" v-model="text" class="form-control"></textarea>

</div> 

</template>


<script>
    export default {
    	
        props: {
	        type: {},
	        currentData: {}
	    },

	    data() {

            return {

                text: null
               
            }

        },

        created() {

        	this.setText()

        },

	    methods: {
	 
	    	selectChange: function() {

	    		console.log(this.text);

	    		bus.$emit('text-changed', this.type, this.text)


	    	},

	    	setText() {

	    		if(this.currentData.value) {

	    			this.text = this.currentData.value;

	    		} else {
	    			this.text = null;
	    		}

	    	}

	    },
	    
	    watch: {

	    	currentData() {

	    		this.setText()
	    	}

	    }

    }
</script>